import { getCurrencySymbol } from '../../../../utils/getCurrencySymbol'
import { getImageFormat } from '../../../../utils/getImageFormat'

import { ReactComponent as Star } from '../../../../icons/starIcon.svg'
import styles from './SpecialOfferV2.module.scss'
import React, { useState } from 'react'

export const SpecialOfferV2 = ({
  specialOffer,
  setCheckedSpecialOffer,
  checkedSpecialOffer,
  handlePromo,
  handleShowNotification,
  currency,
  result,
  accept_special_offer_oferta,
  setAccept_special_offer_oferta
}) => {
  const [specialOfertaError, setSpecialOfertaError] = useState(false)

  const specialOfferProduct = result?.frame_products?.find(
    (item) => item.special_offer
  )

  const oferta =
    specialOfferProduct?.special_offer_oferta_url ||
    result?.oferta_url ||
    result?.frame_companies?.find(Boolean)?.company_info?.oferta_url

  const handleClick = (e) => {
    e.preventDefault()

    if (!accept_special_offer_oferta) {
      setSpecialOfertaError(true)
    } else {
      if (e.target.checked) handleShowNotification()

      setCheckedSpecialOffer(e.target.checked)
      if (handlePromo) handlePromo(e.target.checked)
    }
    if (!e.target.checked) {
      setAccept_special_offer_oferta(false)
    }
  }

  const handleCheckOferta = (e) => {
    if (e.target.checked) {
      setAccept_special_offer_oferta(e.target.checked)
      setSpecialOfertaError(false)
    } else {
      setAccept_special_offer_oferta(false)
    }
  }

  return (
    <>
      <div data-testid="specialOffer-wrapper" className={styles.root}>
        <div data-testid="specialOffer-header" className={styles.header}>
          <Star data-testid="specialOffer-icon" />
          <p>Специальное предложение для вас!</p>
        </div>

        <div data-testid="specialOffer-content" className={styles.content}>
          <div data-testid="specialOffer-mainInfo" className={styles.mainInfo}>
            {specialOffer?.image_url && (
              <img
                src={getImageFormat(specialOffer.image_url, '_')}
                className={styles.img}
                alt="file"
                data-testid="specialOffer-img"
              />
            )}

            <div
              data-testid="specialOffer-rightSide"
              className={styles.rightSide}
            >
              <div data-testid="specialOffer-title" className={styles.title}>
                {specialOffer.name || specialOffer.product_info.name}
              </div>
              <div data-testid="specialOffer-price" className={styles.price}>
                {specialOffer.price?.toLocaleString('ru-RU') ||
                  specialOffer.product_info.price?.toLocaleString('ru-RU')}
                {getCurrencySymbol(currency)}
              </div>
            </div>
          </div>

          <div data-testid="specialOffer-divider" className={styles.divider} />

          <div
            data-testid="specialOffer-description"
            className={styles.description}
          >
            {specialOffer.description}
          </div>
        </div>

        <div>
          <div data-testid="special-oferta-terms" className={styles.rowBox}>
            <input
              type="checkbox"
              className={`${styles.customCheckbox} ${specialOfertaError && styles.inputError}`}
              data-testid="special-oferta"
              id="special-oferta"
              name="special-oferta"
              value={accept_special_offer_oferta}
              checked={accept_special_offer_oferta}
              onChange={(e) => handleCheckOferta(e)}
              disabled={checkedSpecialOffer}
              required
            />
            <label data-testid="label-special-oferta" htmlFor="special-oferta">
              Я ознакомлен(-на) с условиями{' '}
              <a href={oferta} target="_blank">
                лицензионного договора{' '}
              </a>
              специального предложения
            </label>
          </div>
          {specialOfertaError && (
            <div
              data-testid="special-oferta-error"
              className={styles.errorText}
            >
              Необходимо согласиться с условиями
            </div>
          )}
        </div>

        <label
          className={styles.checkboxLabel}
          style={checkedSpecialOffer ? { border: 'none' } : {}}
        >
          <input
            type="checkbox"
            checked={checkedSpecialOffer}
            onChange={(e) => handleClick(e)}
            className={styles.checkboxInput}
          />
          <span className={styles.checkboxText}>
            {checkedSpecialOffer ? 'Удалить из заказа' : 'Добавить к заказу'}
          </span>
        </label>
      </div>
    </>
  )
}
